import React from "react";
import { Environment } from "@/types";

const EnvironmentContext = React.createContext<Environment>("Production");

export default EnvironmentContext;
